export const SET_LOCAL_BENEFIT_GROUPS = "SET_LOCAL_BENEFIT_GROUPS";
export const SET_LOCAL_BENEFIT_GROUPS_PAGE = "SET_LOCAL_BENEFIT_GROUPS_PAGE";
export const EDIT_LOCAL_BENEFIT_GROUP = "EDIT_LOCAL_BENEFIT_GROUP";
export const ADD_NEW_LOCAL_BENEFIT_TO_LOCAL_BENEFIT_GROUP =
  "ADD_NEW_LOCAL_BENEFIT_TO_LOCAL_BENEFIT_GROUP";
export const EDIT_LOCAL_BENEFIT = "EDIT_LOCAL_BENEFIT";
export const DELETE_LOCAL_BENEFIT = "DELETE_LOCAL_BENEFIT";
